export const FEATURES = {
  NOVA:             process.env.REACT_APP_FEAT_NOVA === 'true',
  NOVA_MEMORY:      process.env.REACT_APP_FEAT_NOVA_MEMORY === 'true',
  NOVA_WHATSAPP:    process.env.REACT_APP_FEAT_NOVA_WA === 'true',
  NOVA_INSPECTION:  process.env.REACT_APP_FEAT_NOVA_INSPECT === 'true',
  NOVA_BUILDER:     process.env.REACT_APP_FEAT_NOVA_BUILDER === 'true',
};
